import { useState } from "react";
import { Router, Route, Switch } from "wouter";
import LandingPage from "@/pages/LandingPage";
import EarlyAccessPage from "@/pages/EarlyAccessPage";

export type Lang = "en" | "pt";

function detectLang(): Lang {
  // Check localStorage first (user's explicit choice persists)
  const stored = localStorage.getItem("lexiun-lang");
  if (stored === "en" || stored === "pt") return stored;

  // Auto-detect from browser settings
  const pref = (navigator.languages?.[0] ?? navigator.language ?? "").toLowerCase();
  if (pref.startsWith("en")) return "en";
  return "pt";
}

export default function App() {
  const [lang, setLang] = useState<Lang>(detectLang);

  const handleSetLang = (newLang: Lang) => {
    setLang(newLang);
    localStorage.setItem("lexiun-lang", newLang);
  };

  return (
    <Router>
      <Switch>
        <Route path="/early-access">
          <EarlyAccessPage lang={lang} setLang={handleSetLang} />
        </Route>
        <Route path="/">
          <LandingPage lang={lang} setLang={handleSetLang} />
        </Route>
      </Switch>
    </Router>
  );
}
